<template>
    <div class="corporateCulture">
        <!--banner start-->
        <div class="culture_banner"></div>
        <!--banner end-->

        <!--企业文化 start-->
        <div class="corporate_culture_show">
            <div class="contentWidth">
                <h2>企业文化</h2>
                <ul class="ly_flex ly_flex_wrap_wrap ly_flex_just_between">
                    <li class="corporate_culture_list"
                        v-for="item in corporateCultureList"
                        :key="item.key">
                        <img class="list_img" :src="item.imgPath" alt="">
                        <p class="list_content">{{item.content}}</p>
                        <p class="list_title">{{item.title}}</p>
                    </li>
                </ul>
            </div>
        </div>

        <!--企业文化 end-->

    </div>
</template>

<script>
    export default {
        name: "corporateCulture",
        data(){
            return{
                corporateCultureList:[
                    {
                        imgPath:require('@/assets/img/corporateCulture1.png'),
                        content:'以任务为核心的',
                        title:'团队协作'
                    },
                    {
                        imgPath:require('@/assets/img/corporateCulture2.png'),
                        content:'建立职业化的',
                        title:'企业形象'
                    },
                    {
                        imgPath:require('@/assets/img/corporateCulture3.png'),
                        content:'制造愉悦的',
                        title:'公司环境'
                    },
                    {
                        imgPath:require('@/assets/img/corporateCulture4.png'),
                        content:'鼓励竞争的',
                        title:'高效机制'
                    },
                    {
                        imgPath:require('@/assets/img/corporateCulture5.png'),
                        content:'员工为首的',
                        title:'人文关怀'
                    },
                    {
                        imgPath:require('@/assets/img/corporateCulture6.png'),
                        content:'有利于创新的',
                        title:'宽松范围'
                    }
                ]
            }
        }
    }
</script>

<style scoped lang="scss">
    .corporateCulture{
        .culture_banner{
            width: 100%;
            height: 306px;
            background: url("../../../public/img/corporateCultur/corporateCultureBanner.png");
            background-size: 100% 100%;
        }

        .corporate_culture_show{
            padding-top:120px;
            width: 100%;
            height: 1108px;
            h2{
                margin-bottom: 70px;
                text-align: center;
                font-size: 40px;
                line-height: 40px;
                font-weight: 600;
                color: #333333;
            }

            .corporate_culture_list{
                margin-bottom: 31px;
                width:377px;
                height:400px;
                border:1px solid #CBCBCB;
                .list_img{
                    margin-bottom: 17px;
                    width:375px;
                    height: 260px;
                }
                p{
                    text-align: center;
                    font-size:18px;
                    line-height: 18px;
                }
                .list_content{
                    margin-bottom: 14px;
                    color:#9F9F9F;
                }
                .list_title{
                    color:#1C97D5;
                }
            }
        }
    }
</style>